export default __webpack_public_path__ + "static/media/register3.feb42604.jpg";